import React, { useEffect, useState } from "react";
import { purchasedApi } from "../../api/auctiongate.js";

export default function PurchasedLots() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await purchasedApi.list();
        if (cancelled) return;
        const arr = Array.isArray(r) ? r : r?.data ?? r?.items ?? [];
        setItems(Array.isArray(arr) ? arr : []);
      } catch (e) {
        if (cancelled) return;
        // Treat 4xx as "no data" so the UI stays clean for accounts without purchases.
        if (e?.status && e.status >= 400 && e.status < 500) {
          setItems([]);
        } else {
          setError(e?.message || "Failed to load purchased lots");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="card">
      <div className="card__title">Purchased Lots</div>
      {loading && <span className="loader" />}
      {error && <div className="login-error">{error}</div>}
      {!loading && !error && items.length === 0 && (
        <div className="placeholder-panel">No purchased lots yet.</div>
      )}
      {items.length > 0 && (
        <div className="stack">
          {items.slice(0, 20).map((it, idx) => (
            <div key={it.id ?? idx} style={rowStyle}>
              <div>
                <div style={{ fontWeight: 600 }}>
                  {it.vehicle || it.title || `Lot ${it.lot_number ?? "?"}`}
                </div>
                <div className="small muted">
                  {it.auction && <>Auction: <b>{it.auction}</b> · </>}
                  {it.lot_number && <>Lot: <b>{it.lot_number}</b> · </>}
                  {it.vin && <>VIN: <span style={{ fontFamily: "monospace" }}>{it.vin}</span></>}
                </div>
              </div>
              {it.price && <div><b>${it.price}</b></div>}
            </div>
          ))}
          {items.length > 20 && <div className="small muted text-center">…and {items.length - 20} more</div>}
        </div>
      )}
    </div>
  );
}

const rowStyle = {
  padding: "10px 12px",
  border: "1px solid var(--color-border)",
  borderRadius: 8,
  background: "var(--color-bg-card-elevated)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
